import { put, select, takeLatest } from 'redux-saga/effects'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { getAirwaySelector } from '../../procedures/airway/selectors'
import { IAirwayState } from '../../procedures/airway/store/airway.types'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import { saveTimelineItems, setActivityLog } from '../store/timeline.actions'
import { TimelineConstants } from '../store/timeline.constants'
import { IItem, ITimelineState } from '../store/timeline.types'
import { generateClientCorrelationId } from '../../nemsisData/utils/customElements.util'
import { getProcedureStateSelector } from '../../../components/procedure/selectors'

export function* addAirwayItem() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { nemsisCodeOptions } = yield select(getProcedureStateSelector)

  const { items } = timeline
  const airwayState: IAirwayState = yield select(getAirwaySelector)
  const {
    pta,
    addToTimeline,
    action,
    flow,
    fiO2,
    via,
    humidity,
    oralPharyngealAirway,
    airTemperature,
    airTemperatureUnit,
    pressure,
    inspiratoryPressure,
    expiratoryPressure,
    key,
    time,
    date,
    assessedBy,
    attempts,
    successfulAttempt,
    comments,
    isEkgImport,
  } = airwayState

  const clientCorrelationId = generateClientCorrelationId(
    nemsisCodeOptions,
    TimelineConstants.AIRWAY_PROCEDURE,
    action?.name || '',
    { filter1: pressure, filter2: inspiratoryPressure, filter3: expiratoryPressure },
    key
  )
  if (addToTimeline) {
    const showVia = action?.name === 'Oxygen' ? true : false
    const showOralPharyngealAirway = action?.name === 'Bag Valve Mask' ? true : false
    const showPressure = action?.name === 'CPAP' ? true : false
    const showInspiratoryPressure = action?.name === 'BiPAP' ? true : false
    const showExpiratoryPressure = action?.name === 'BiPAP' ? true : false
    const successfulAttemptLabel = successfulAttempt ? 'Yes' : 'No'
    const index = items.findIndex((item) => item.key === key)
    const dateTime = new Date(date || 0)
    if (time) {
      if (time.split(':').length >= 3) dateTime.setSeconds(+time.split(':')[2])
      dateTime.setMinutes(+time.split(':')[1])
      dateTime.setHours(+time.split(':')[0])
    }
    const item: IItem = {
      key: key,
      clientCorrelationId,
      grid: true,
      labelHeaderFlag: pta ? 'PTA' : '',
      labelHeader: time,
      subHeader: date,
      itemType: 'Procedures',
      event: 'Airway',
      eventSubHeader: `By ${assessedBy?.name || ''}, Action: ${action?.name || ''}, Flow: ${flow}, FiO2: ${fiO2},
      Humidity: ${humidity}, Air Temperature: ${airTemperature}° ${airTemperatureUnit?.name?.toUpperCase() || ''},
      ${showVia ? 'Via: ' + (via?.name || '') + ', ' : ''}
      ${showOralPharyngealAirway ? 'Oral Pharyngeal Airway: ' + oralPharyngealAirway + ', ' : ''}
      ${showPressure ? 'Pressure: ' + pressure + ', ' : ''}
      ${showInspiratoryPressure ? 'Inspiratory Pressure: ' + inspiratoryPressure + ', ' : ''}
      ${showExpiratoryPressure ? 'Expiratory Pressure: ' + expiratoryPressure + ', ' : ''}
      Attempts: ${attempts}, Success: ${successfulAttemptLabel}, Comments: ${comments}.`,
      rowActionType: TimelineConstants.SET_AIRWAY_PROCEDURE_ITEM,
      defaultHref: TabConstants.AIRWAY_PROCEDURE,
      date: dateTime,
      ...(isEkgImport && { isEkgImport: isEkgImport }),
    }
    if (index !== -1) {
      items[index] = item
    } else {
      items.push(item)
    }
    yield put(setActivityLog(items))
    yield put(saveTimelineItems())
  }
}

export function* addAirwayItemSaga() {
  yield takeLatest([TimelineConstants.ADD_AIRWAY_ITEM], addAirwayItem)
}
